import React from 'react';
import Star from './Star';
import PropTypes from 'prop-types';
import styles from './StarRating.module.less';

const StarRating = props => {
  let stars = [1, 2, 3, 4, 5].map(i => {
    let width;
    if (props.rating >= i) {
      width = 1;
    } else if (props.rating <= i - 1) {
      width = 0;
    } else {
      width = 1 - (i - props.rating);
    }

    return <Star width={width} key={i} />;
  });

  return (
    <div className={styles.starRating}>
      <div className={styles.stars}>{stars}</div>
    </div>
  );
};
StarRating.displayName = 'StarRating';
StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
};

export default StarRating;
